class QuickView extends HTMLElement {
  constructor() {
    super();
    this.productUrl = this.getAttribute("data-url");
    this.productForm = this.closest('form[action="/cart/add"]');
    this.variantPicker = this.querySelector("variant-picker");
    this.variantFieldset = this.variantPicker?.querySelectorAll("fieldset");
    this.variantData = JSON.parse(
      this.querySelector(".variant-data")?.textContent,
    );
    this.customizeCheckbox = this.querySelector(
      ".customize-my-notebook .customize-my-notebook-checkbox",
    );
    this.fontSelector = this.querySelector(".gpo-font-picker");
    this.initialPrice = this.getAttribute("data-initial-price");
    this.gpoGroupId = 0;
    this.atcButton = this.querySelector(
      'add-to-cart-component button[name="add"]',
    );
  }

  connectedCallback() {
    this.enableDotScroll();
    this.querySelector(".open-quick-view")?.addEventListener("click", (event) => {
      event.preventDefault();
      this.querySelector("dialog-component")?.showDialog(event);
    });
    this.querySelector("dialog-component")?.addEventListener(
      "dialog:open",
      () => {
        this.querySelectorAll("slideshow-component").forEach((slideshow) => {
          slideshow.updateVisibleSlides();
        });
        this.querySelector("variant-picker").dispatchEvent(new Event("change"));
        this.loadDescriptions();
        document.querySelector("body").classList.add("quick-view-open");
      },
    );
    this.querySelector("dialog-component")?.addEventListener(
      "dialog:close",
      () => {
        document.querySelector("body").classList.remove("quick-view-open");
      },
    );

    this.querySelector(".add-to-cart-text__content").textContent =
      `${this.addToCart(Number(this.initialPrice) / 100)}`;
    this.querySelector("variant-picker")?.addEventListener(
      "variant:update",
      (e) => {
        this.updateVariant(e);
      },
    );
    this.querySelector("variant-picker")?.addEventListener(
      "variant:update:error",
      () => {
        this.updateVariant();
      },
    );
    if (this.customizeCheckbox) {
      this.customizeCheckbox?.addEventListener("change", () => {
        this.customizeNotebook();
      });
      this.fontSelector
        .querySelectorAll('input[name="Font"]')
        .forEach((radio) => {
          radio.addEventListener("change", (evt) => {
            const font = evt.target.value;
            this.querySelector(".gpo-input-wrap input").style.fontFamily = font;
            this.customizeNotebook();
          });
        });
      this.querySelector('.gpo-input-wrap [name="Name"]')?.addEventListener(
        "change",
        () => {
          this.customizeNotebook();
        },
      );
      this.querySelector('[ref="addToCartButton"]')?.addEventListener(
        "click",
        () => {
          const variantId = 46310582419611;
          if (this.customizeCheckbox.checked) {
            let formData = {
              items: [
                {
                  id: variantId,
                  quantity: parseInt(
                    this.querySelector('[name="quantity"]').value,
                  ),
                  properties: {
                    _gpo_parent_product_group: this.gpoGroupId,
                    _gpo_field_name: "checkbox-1",
                  },
                },
              ],
            };

            fetch(window.Shopify.routes.root + "cart/add.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(formData),
            })
              .then((response) => {
                return response.json();
              })
              .catch((error) => {
                console.error("Error:", error);
              });
          }
        },
      );
    }
  }
  enableDotScroll() {
    const slider = this.querySelector("ol.slideshow-controls__dots");
    if (!slider) return;

    let isDown = false;
    let startX;
    let scrollLeft;

    slider.addEventListener("mousedown", (e) => {
      isDown = true;
      slider.style.cursor = "grabbing";
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });

    slider.addEventListener("mouseleave", () => {
      isDown = false;
      slider.style.cursor = "grab";
    });

    slider.addEventListener("mouseup", () => {
      isDown = false;
      slider.style.cursor = "grab";
    });

    slider.addEventListener("mousemove", (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 1.5;
      slider.scrollLeft = scrollLeft - walk;
    });
  }

  addToCart(price) {
    return `Add to cart - $${price}`;
  }
  updateVariant(event = null) {
    this.atcButton.disabled = true;
    if (event) {
      let newVarId;
      if (event.detail.resource) {
        if (event.detail.resource.available === false) {
          newVarId = "sold out";
        } else {
          newVarId = event.detail.resource.id;
        }
      } else if (event.detail.resource === null) {
        newVarId = "sold out";
      }
      if (newVarId !== "sold out") {
        const matchedValues = this.findById(newVarId);
        this.productForm
          ?.querySelector('[name="id"]')
          ?.setAttribute("value", matchedValues.id);
        this.querySelector(".add-to-cart-text__content")
          ?.closest('[name="add"]')
          ?.removeAttribute("disabled");
        this.querySelector(".add-to-cart-text__content").textContent =
          `${this.addToCart(Number(matchedValues?.price) / 100)}`;
        this.querySelector(".product-price").textContent =
          `$${(Number(matchedValues?.price) / 100)}`;
        this.#toggleBisForm(false);
      } else {
        this.querySelector(".add-to-cart-text__content")
          ?.closest('[name="add"]')
          ?.setAttribute("disabled", "");
        this.querySelector(".add-to-cart-text__content").textContent =
          "Sold Out";
        this.#toggleBisForm(true);
      }
    } else {
      let options = [];
      let hasSoldout = [];
      this.variantFieldset?.forEach((option) => {
        options.push(option.querySelector("input:checked").value);
        if (
          option
            .querySelector("input:checked")
            ?.getAttribute("data-option-available") === false ||
          option
            .querySelector("input:checked")
            ?.getAttribute("data-option-available") === "false"
        ) {
          hasSoldout.push(true);
        } else {
          hasSoldout.push(false);
        }
      });
      // eslint-disable-nextline
      if (hasSoldout.every((option) => option === true) === false) {
        const matchedValues = this.findExactMatch(options);
        this.productForm
          ?.querySelector('[name="id"]')
          ?.setAttribute("value", matchedValues.id);
        this.querySelector(".add-to-cart-text__content").textContent =
          `${this.addToCart(Number(matchedValues?.price) / 100)}`;
        this.querySelector(".product-price").textContent =
          `$${(Number(matchedValues?.price) / 100)}`;
        this.atcButton.disabled = false;
        this.#toggleBisForm(false);
      } else {
        this.querySelector(".add-to-cart-text__content")
          ?.closest('[name="add"]')
          ?.setAttribute("disabled", "");
        this.querySelector(".add-to-cart-text__content").textContent =
          "Sold Out";
        this.#toggleBisForm(true);
      }
    }
  }
  /** @param {boolean} soldOut */
  #toggleBisForm(soldOut) {
    const buyButtons = /** @type {HTMLElement|null} */ (this.querySelector("[data-qv-buy-buttons]"));
    const bisContainer = /** @type {HTMLElement|null} */ (this.querySelector("[data-qv-bis-container]"));
    const bisForm = /** @type {HTMLElement|null} */ (bisContainer?.querySelector("[data-variant-id]"));

    if (buyButtons) buyButtons.style.display = soldOut ? "none" : "";
    if (bisContainer) bisContainer.style.display = soldOut ? "" : "none";

    if (soldOut && bisForm && this.variantData) {
      /** @type {string[]} */
      const options = [];
      this.variantFieldset?.forEach((option) => {
        const checked = /** @type {HTMLInputElement|null} */ (option.querySelector("input:checked"));
        if (checked) options.push(checked.value);
      });
      const match = this.findExactMatch(options);
      if (match) (/** @type {HTMLElement} */ (bisForm)).dataset.variantId = match.id;
    }
  }
  findExactMatch(valuesToFind) {
    const match = this.variantData.find((item) => {
      const options = [item.option1, item.option2, item.option3].filter(
        (v) => v !== null,
      );

      return (
        options.length === valuesToFind.length &&
        valuesToFind.every((v) => options.includes(v))
      );
    });
    return match ? { id: match.id, price: match.price } : null;
  }
  findById(id) {
    const item = this.variantData.find((v) => v.id === id);
    return item ? { id: item.id, price: item.price } : null;
  }

  customizeNotebook() {
    if (this.customizeCheckbox.checked) {
      const variant = this.customizeCheckbox?.getAttribute(
        "gpo-data-variant-id",
      );
      const font = this.querySelector('.gpo-font-picker input[name="Font"]');
      const name = this.querySelector('.gpo-input-wrap [name="Name"]');
      if (this.productForm?.querySelector(".gpo-hidden-inputs")) {
        this.productForm?.querySelector(".gpo-hidden-inputs")?.remove();
      }
      const nowInMilliseconds = Number(new Date());
      this.gpoGroupId = nowInMilliseconds;
      const gpoHiddenInputs = document.createElement("div");
      gpoHiddenInputs.classList.add("gpo-hidden-inputs");
      gpoHiddenInputs.insertAdjacentHTML(
        "beforeend",
        `<input type="text" id="validator" style="display:none;opacity:0;height:0;width:0;padding:0;border:none;margin:0;" />`,
      );

      gpoHiddenInputs.insertAdjacentHTML(
        "beforeend",
        `<input type="hidden" name="properties[_gpo_product_group]" value="${this.gpoGroupId}" />`,
      );
      gpoHiddenInputs.insertAdjacentHTML(
        "beforeend",
        `<input type="hidden" name="properties[_has_gpo]" value="1247671" />`,
      );
      gpoHiddenInputs.insertAdjacentHTML(
        "beforeend",
        `<input type="hidden" data-field-name="checkbox-1" data-multiple="true" value="Customize my notebook! -" data-value="Customize my notebook! -" name="properties[checkbox-1]" gpo-data-variant-id="46310582419611" gpo-data-product-handle="option-set-1021143-text-1" />`,
      );
      if (name.value) {
        gpoHiddenInputs.insertAdjacentHTML(
          "beforeend",
          `<input type="hidden" data-field-name="Name" value="${name.value}" data-value="${name.value}" name="properties[Name]"/>`,
        );
      }
      if (font.value) {
        gpoHiddenInputs.insertAdjacentHTML(
          "beforeend",
          `<input type="hidden" data-field-name="Font" value="${font.value}" data-value="${font.value}" name="properties[Font]" />`,
        );
      }

      this.productForm?.insertAdjacentElement("beforeend", gpoHiddenInputs);
    } else {
      if (this.productForm?.querySelector(".gpo-hidden-inputs")) {
        this.productForm?.querySelector(".gpo-hidden-inputs")?.remove();
      }
    }
  }

  loadDescriptions() {
    async function loadText(url) {
      const response = await fetch(url);
      const text = await response.text();

      const parser = new DOMParser();
      const doc = parser.parseFromString(text, "text/html");

      return doc;
    }

    loadText(this.productUrl).then((doc) => {
      const pdpDetails = doc.querySelector(
        ".product-information__grid .product-details",
      );
      const accordion = doc.querySelector(".accordion");
      const badgesMedia = doc.querySelector(".icon-block__media");
      const badges = badgesMedia
        ? badgesMedia.closest('.group-block[class*="color-scheme"]')
        : null;
      if (badges) {
        badges.removeAttribute("style");
      }
      if (accordion) {
        this.querySelector(".product-accordions-element")?.replaceWith(
          accordion,
        );
      }
      if (badges) {
        this.querySelector(".trust-badges")?.replaceWith(badges);
        this.querySelector(".trust-badges-outer-wrapper")?.classList.remove(
          "hidden",
        );
      }
    }).catch((error) => {
      console.error("Quick view: failed to load descriptions", error);
    });
  }
}

if (!customElements.get("quick-view")) {
  customElements.define("quick-view", QuickView);
}
